export default "/react/logoTolty-c7a1aefb.png";